{
  "checkedInTitle": "Ви зареєструвались",
  "postCheckInInstructions": "Інструкції після реєстрації",
  "appointmentDetails": "Деталі призначення",
  "notifyWarehouse": "Ми повідомили склад про ваше прибуття, щоб вони могли перевірити свою доступність",
  "waitForStaff": "Будь ласка, очікуйте подальших інструкцій від персоналу складу",
  "unplannedDescription": "Схоже, у вас немає запису. Будь ласка, очікуйте подальших інструкцій від персоналу складу.",
  "whatsappDelay": "Перше повідомлення WhatsApp може надійти з затримкою до однієї хвилини.",
  "bookNextTitle": "Забронюйте призначення на наступний раз",
  "bookNextBody": "Зареєструйтесь в Opendock, щоб забронювати призначення наступного разу, коли відвідаєте цей об'єкт",
  "helpFooter": "Якщо вам потрібна допомога або додаткова інформація, зверніться до персоналу складу",
  "finalize": "Завершити ({seconds})"
}
